import React from 'react';
import { getFullImageUrl } from '../../utils/config';
import defaultLogo from '../../assets/images/logo.png';
import { FaEye, FaFileAlt, FaHeart, FaEnvelope } from 'react-icons/fa';
import './PropertyStatsTable.css';

const PropertyStatsTable = ({ properties, onPropertySelect, requestSort, sortConfig }) => {
  if (!properties || properties.length === 0) {
    return <p>No properties to display statistics for.</p>;
  }

  return (
    <div className="property-stats-table-container">
      <table className="property-stats-table">
        <thead>
          <tr>
            <th onClick={() => requestSort('propertyID')} className="sortable-header">
              <div className="sortable-header-content">
                <div className="header-icons-group">
                  <span className="sort-indicator">
                    <span className={`sort-arrow up ${sortConfig.key === 'propertyID' && sortConfig.direction === 'ascending' ? 'active' : ''}`}>&#9650;</span>
                    <span className={`sort-arrow down ${sortConfig.key === 'propertyID' && sortConfig.direction === 'descending' ? 'active' : ''}`}>&#9660;</span>
                  </span>
                </div>
                <span className="header-text">ID</span>
              </div>
            </th>
            <th>Image</th>
            <th onClick={() => requestSort('address')} className="sortable-header">
              <div className="sortable-header-content">
                <div className="header-icons-group">
                  <span className="sort-indicator">
                    <span className={`sort-arrow up ${sortConfig.key === 'address' && sortConfig.direction === 'ascending' ? 'active' : ''}`}>&#9650;</span>
                    <span className={`sort-arrow down ${sortConfig.key === 'address' && sortConfig.direction === 'descending' ? 'active' : ''}`}>&#9660;</span>
                  </span>
                </div>
                <span className="header-text">Address</span>
              </div>
            </th>
            <th onClick={() => requestSort('views')} className="sortable-header">
              <div className="sortable-header-content">
                <div className="header-icons-group">
                  <span className="sort-indicator">
                    <span className={`sort-arrow up ${sortConfig.key === 'views' && sortConfig.direction === 'ascending' ? 'active' : ''}`}>&#9650;</span>
                    <span className={`sort-arrow down ${sortConfig.key === 'views' && sortConfig.direction === 'descending' ? 'active' : ''}`}>&#9660;</span>
                  </span>
                  <FaEye className={`header-stat-icon ${sortConfig.key === 'views' ? 'active' : ''}`} />
                </div>
                <span className="header-text">Views</span>
              </div>
            </th>
            <th onClick={() => requestSort('reports')} className="sortable-header">
              <div className="sortable-header-content">
                <div className="header-icons-group">
                  <span className="sort-indicator">
                    <span className={`sort-arrow up ${sortConfig.key === 'reports' && sortConfig.direction === 'ascending' ? 'active' : ''}`}>&#9650;</span>
                    <span className={`sort-arrow down ${sortConfig.key === 'reports' && sortConfig.direction === 'descending' ? 'active' : ''}`}>&#9660;</span>
                  </span>
                  <FaFileAlt className={`header-stat-icon ${sortConfig.key === 'reports' ? 'active' : ''}`} />
                </div>
                <span className="header-text">Reports</span>
              </div>
            </th>
            <th onClick={() => requestSort('saves')} className="sortable-header">
              <div className="sortable-header-content">
                <div className="header-icons-group">
                  <span className="sort-indicator">
                    <span className={`sort-arrow up ${sortConfig.key === 'saves' && sortConfig.direction === 'ascending' ? 'active' : ''}`}>&#9650;</span>
                    <span className={`sort-arrow down ${sortConfig.key === 'saves' && sortConfig.direction === 'descending' ? 'active' : ''}`}>&#9660;</span>
                  </span>
                  <FaHeart className={`header-stat-icon ${sortConfig.key === 'saves' ? 'active' : ''}`} />
                </div>
                <span className="header-text">Saves</span>
              </div>
            </th>
            <th onClick={() => requestSort('inquiries')} className="sortable-header">
              <div className="sortable-header-content">
                <div className="header-icons-group">
                  <span className="sort-indicator">
                    <span className={`sort-arrow up ${sortConfig.key === 'inquiries' && sortConfig.direction === 'ascending' ? 'active' : ''}`}>&#9650;</span>
                    <span className={`sort-arrow down ${sortConfig.key === 'inquiries' && sortConfig.direction === 'descending' ? 'active' : ''}`}>&#9660;</span>
                  </span>
                  <FaEnvelope className={`header-stat-icon ${sortConfig.key === 'inquiries' ? 'active' : ''}`} />
                </div>
                <span className="header-text">Inquiries</span>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {properties.map((prop) => (
            <tr key={prop.propertyID} onClick={() => onPropertySelect(prop)} title="Click to view/edit details">
              <td data-label="ID">{prop.propertyID}</td>
              <td data-label="Image">
                <img src={prop.mainImageURL ? getFullImageUrl(prop.mainImageURL) : defaultLogo} alt={`${prop.address}`} className="stats-table-thumbnail" onError={(e) => (e.target.src = defaultLogo)} />
              </td>
              <td data-label="Address">{`${prop.address || ''}, ${prop.city || ''}, ${prop.state || ''} ${prop.zipCode || ''}`}</td>
              <td data-label="Views">{prop.stats?.viewCount || 0}</td>
              <td data-label="Reports">{prop.stats?.reportCount || 0}</td>
              <td data-label="Saves">{prop.stats?.saveCount || 0}</td>
              <td data-label="Inquiries">{prop.stats?.inquiryCount || 0}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PropertyStatsTable;
